import { DataSource, TableColumn } from "components/molecules/Table";
import { getDisplayInfo } from "utils/formatting";

export const buildCarbonPoliciesTableData = (
    policiesData: { policies: CarbonPoliciesTableDatum[] },
    columns: string[]
): {
    columns: TableColumn[];
    dataSource: DataSource[];
} => {
    const { policies } = policiesData;

    const dataSource = policies.map((policy) => ({
        ...policy,
        buildingsImpacted: policy.buildingModelUids.length,
        key: policy.id || policy.name,
    }));

    const tableColumns = columns.map((column) => {
        const { formatFunction, humanReadable, unit } = getDisplayInfo(column);

        return {
            title: `${humanReadable} ${unit ? `(${unit})` : ""}`,
            dataIndex: column,
            key: column,
            render: (value: any) => {
                let formattedValue = value;
                if (formatFunction) {
                    formattedValue = formatFunction(value);
                }
                return <span>{formattedValue}</span>;
            },
        };
    });

    return {
        columns: tableColumns,
        dataSource,
    };
};

export const CarbonPoliciesTableColumns = [
    "name",
    "buildingsImpacted",
    "exposure",
    "grossFloorArea",
    "yearStart",
    "type",
    "limitUnits",
    "fineUnits",
    "fineRate",
    "grossFloorAreaMin",
    "grossFloorAreaMax",
];
